export interface ContactModel {
  title: string;
  icon: string;
  href: string;
  color: string;
}

export const contactItems: ContactModel[] = [
  {
    title: '888.293.0272',
    icon: 'mdi-phone-outline',
    href: 'tel:(888)293-0272',
    color: '#66CCFF'
  },
  {
    title: 'info@awelearning.com',
    icon: 'mdi-email-outline',
    href: 'mailto:info@awelearning.com',
    color: '#6A73DF'
  }
];
